import React from 'react';
import Maybe from 'react-maybe';
import PropTypes from 'prop-types';
import cx from 'classnames';

function Dots({ className }) {
    return (
        <div className={cx('spinner', className)}>
            <i className="spinner__dot spinner__dot--1" />
            <i className="spinner__dot spinner__dot--2" />
            <i className="spinner__dot spinner__dot--3" />
        </div>
    );
}
function Spinner() {
    return (
        <div className="spinner__square">
            <Dots />
        </div>
    );
}
Spinner.Dots = Dots;
Spinner.Plate = function Plate() {
    return (
        <div className="spinner__plate">
            <Spinner />
        </div>
    );
};
Spinner.Loader = function Loader({ isLoading, children }) {
    return (
        <Maybe
            of={isLoading}
            either={<Spinner.Dots />}
            orElse={<>{children}</>}
        />
    );
};

Spinner.Loader.propTypes = {
    isLoading: PropTypes.bool
};
Spinner.Loader.defaultProps = {
    isLoading: false
};

export default Spinner;